/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import Icon from '@ant-design/icons';

const CustomIcon = React.forwardRef((props, _) => <Icon component={props.svg} className={props.className} />);

export default CustomIcon;
